import { render, staticRenderFns } from "./SingleShow.vue?vue&type=template&id=00ed3a4e&"
import script from "./SingleShow.vue?vue&type=script&lang=js&"
export * from "./SingleShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports